import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

interface BirthdayFieldProp {
  setBirthdate: (string) => void;
  birthDate: string;
}

export const BirthdayField: React.FC<BirthdayFieldProp> = ({ birthDate, setBirthdate }) => {
  const dateFormat = 'MM/DD/YYYY';
  const defaultBdate = birthDate ? dayjs(birthDate, dateFormat) : '';
  return (
    <div className="form-field-wrap">
      <label>
        Birthdate<sup>*</sup>
      </label>
      <DatePicker
        className="bz-date-picker"
        defaultValue={defaultBdate}
        disabledDate={current => {
          return current && current > dayjs().endOf('day');
        }}
        format={dateFormat}
        onChange={val => {
          const d = val != '' ? (val as dayjs.Dayjs)?.format(dateFormat) : '';
          setBirthdate(d);
        }}
      />
    </div>
  );
};
